<template>
    <b-row>
        <b-col cols="12">
            <b-form-group>
                <v-select v-if="categories != null" v-model="selected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name" :options="categories"
                    class="select-size-lg" single>
                    <template #option="{ name }">
                        <span> {{ name }}</span>
                    </template>
                </v-select>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        vSelect,
    },
    created() {
        this.fetchCategories()

    },
    props: {
        initialId: {
            type: Number,
            default: null
        },
    },


    methods: {
        updateSelections(a) {

            //console.log(a)
        },
        fetchCategories() {
            return new Promise((resolve, reject) => {
                axios
                    .get('admin/f/clientdepartments')
                    .then((response) => {
                        const data = response.data;
                        const responseData = JSON.parse(JSON.stringify(data));
                        this.categories = responseData.data;

                        // Eğer initialId varsa ve eşleşen bir kategori bulunursa onu seç
                        if (this.initialId !== null) {
                            const found = this.categories.find(item => item.id === this.initialId);
                            if (found) {
                                this.selected = found;
                            }
                        } else {
                            this.selected = null;
                        }

                        resolve();
                    })
                    .catch(error => reject(error));
            });
        }

    },
    watch: {
        selected: function (newVal, coldVal) {
            this.$emit("selectionChanged", newVal);
        },
        initialId: function (newVal, coldVal) {
            const found = this.categories.find(item => item.id === newVal);
            if (found) {
                this.selected = found;
            }
        }
    },
    data() {
        return {
            categories: null,
            selected: null,
        }
    }
}
</script>